import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import { SEASONAL_FILTER_OPTIONS } from '../../../constants/PlayPreferenceConstant';
import './Seasonal.scss';
import DropdownInput from '../../../components/selector/DropdownInput';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const seasonalFilterOptions = SEASONAL_FILTER_OPTIONS.map((s) => ({
  id: s.value,
  name: s.name,
}));
const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
  loading: false,
};

const Seasonal = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback, loading } = mergedProps;
  const [filter, setFilter] = useState(profile.filter);
  // When mounting and changing a profile.
  useEffect(() => {
    setFilter(profile.filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const onFilterChange = async (event) => {
    setFilter(event.target.value);
    onChangeCallback(event.target.value);
  };

  return (
    <Box display='flex' className='seasonal-filter-flexbox' data-test='sesonal-filter-container'>
      <FormControl variant='outlined'>
        <DropdownInput
          dropdownValues={seasonalFilterOptions}
          label='Seasonal Filter'
          labelVariant='h6'
          value={filter}
          onChange={onFilterChange}
          className='seasonal-filter-select'
          data-test='seasonal-filter-select'
        />
        {loading ? <CircularProgress className='saving-icon' /> : null}
      </FormControl>
    </Box>
  );
};

export default Seasonal;
